import { useRouter } from "next/router"
import { extractNumberFromQueryString } from "common/lib/queryString"
import { usePageProps } from "common/hooks/data/usePageProps"
import type { NewslettersPageProps } from "pages/newsletters/index.page"
import type { NewsletterGroupItem } from "modules/newsletters/types"
import { useMemo } from "react"

/**
 * Returns newsletter groups from the page props, and the newsletter the `promoted` query
 * string names, if it's on the page.
 */
export const useNewsletterGroups = () => {
  const { query } = useRouter()
  const { groups } = usePageProps<NewslettersPageProps>()

  return useMemo(() => {
    if (!groups.length) {
      return { groups, promotedNewsletter: undefined }
    }

    /*
     * The `promoted` query string names a newsletter to lead the page with, so links from
     * campaigns and Member Services redirects can pre-select it. Without one, the page
     * keeps the order editors gave the groups.
     */
    const promotedIdQueryString = extractNumberFromQueryString(query.promoted)

    const promotedNewsletter: NewsletterGroupItem | undefined = groups
      .flatMap((group) => group.groupItems)
      .find((item) => item.id === promotedIdQueryString)

    return { groups, promotedNewsletter }
  }, [groups, query])
}
